import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";

import MxFormTextNumberField, {
  MxFormTextNumberFieldProps
} from "@rf-l2/form/text-fields/MxFormTextNumberField";
interface MxFormL3TextNumberProps extends MxFormTextNumberFieldProps {
  name: string;
  withreacthookform?:1|0;
}
const MxFormL3TextNumber = (props: MxFormL3TextNumberProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormTextNumberField label={props.label} {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3TextNumber;
